<template>
  <div class="claim__item claim__item--path head">
    <lennoc-icon :image="messageIcon" :class="iconClass" />
    <h3 class="messages--title title--l">{{ header }}</h3>
    <p class="timestamp">{{ dateTime }}</p>
    <base-flex-message
      :message="message"
      :opentext="getUiString(['claim_details','claim','read_more'])"
      :closetext="getUiString(['claim_details','claim','read_less'])"
    ></base-flex-message>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/datetime'

export default {
  name: 'ClaimNestedDocument',
  props: {
    Document: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    }),
    message () {
      return this.Document.Message || ''
    },
    header () {
      return this.Document.Description || this.Document.Name || ''
    },
    action () {
      return this.Document.DocumentAction || ''
    },
    dateTime () {
      return formatDate(this.Document.TimeStamp, 'datetime') || 'de datum'
    },
    messageIcon () {
      if (this.action === 'MessageCustomer') {
        return 'user'
      }
      if (this.action === 'MessageAirline') {
        return 'plane-flat'
      }
      return 'logo-icon'
    },
    iconClass () {
      return this.action === 'MessageEUclaim' ? 'icon icon--logo' : ''
    }
  }
}
</script>
